import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { CondicionesComponent } from '../condiciones/condiciones.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pass-firma',
  templateUrl: './pass-firma.component.html',
  styleUrls: ['./pass-firma.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PassFirmaComponent implements OnInit {
  
  condicionesChecked = false;
  generarFirma = 0;
  constructor( private dialog: MatDialog, 	private router: Router) { }

  ngOnInit() {}

  launchCondiciones(){
    if(this.generarFirma == 1){
      let config = {
        disableClose: true,
        maxWidth: '80vw',
        data: {}
      };
      let dialogRef = this.dialog.open(CondicionesComponent, config);
      dialogRef.afterClosed().subscribe(result => {
        this.condicionesChecked = (result === 'aceptar') ? true : false;
      }); 
    }
  }

  continuar(){
    const generarFirma = this.generarFirma == 1 ? 'true' : 'false'
    localStorage.setItem('generarFirma', generarFirma);
    this.router.navigate(['/recuperar-cuenta/cambiar-pass']);           
  }

}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/recuperar-pass/components/pass-firma/pass-firma.component.ts